import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { StaticImage } from '../../utils/image';
import { Input, Space, Switch } from 'antd';
import { AudioOutlined } from '@ant-design/icons';
import './index.scss';
import './progress.scss';
import SubscribeTab01 from './subscribeTab01';
import SubscribeTab02 from './subscribeTab02';
import SubscribeTab03 from './subscribeTab03';
import ApiMaster from '../../api/master';
import Swal from 'sweetalert2';
import ApiSurvey from '../../api/survey';
import { checkUser } from '../../utils/checkUser';
import { useSelector, useDispatch } from 'react-redux';
import ApiUser from '../../api/user';
import { useHistory } from 'react-router-dom';
import FavoriteHistory from './favoriteHistory';
const SubscribeIndex = () => {
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const [tabFlag0, setTabFlag0] = React.useState(0);
  const [law_group, setlaw_group] = useState([]);
  const tabArr = [
    // {
    //   tabLabel: 'กลุ่มกฎหมาย',
    //   tabIcon: '',
    //   tabLabelIcon: '/images/login/books-duotone-1.png',
    // },
    {
      tabLabel: 'โครงการ',
      tabIcon: '',
      tabLabelIcon: '/images/login/landmark-duotone-4.png',
    },
    // {
    //   tabLabel: 'กฎหมาย',
    //   tabIcon: '',
    //   tabLabelIcon: '/images/login/file-contract-duotone.png',
    // },
  ];
  const [agency, setAgency] = useState([]);
  const [surveyHistory, setsurveyHistory] = useState([]);
  useEffect(() => {
    lawGroup();
    getHistory();
    return () => {};
  }, []);

  const lawGroup = async () => {
    const result = await ApiMaster.lawGroup();
    if (result.status) {
      const { data } = result;
      setlaw_group(data.data);
    }
  };

  const getHistory = async () => {
    Swal.showLoading();
    try {
      const result = await ApiSurvey.favoriteHistory();
      console.log('favorite::', result);
      if (result.status == 200) {
        const { data } = result.data;
        setsurveyHistory(data);
      }
    } catch (error) {}
    Swal.close();
  };

  const handleFavorite = async (e, item) => {
    e.stopPropagation();
    if (checkUser(userState)) {
      Swal.fire({
        title: 'คุณต้องการยกเลิกติดตามแบบสอบถามนี้ใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true,
      }).then(async (ok) => {
        if (ok.isConfirmed) {
          const model = {
            survey_id: item.survey_id,
          };
          try {
            const result = await ApiSurvey.favorite(model);
            if (result.status == 200) {
              //filter
              const likesFilter = [...surveyHistory];
              const filter = likesFilter.filter(
                (x) => parseInt(x.survey_id) != item.survey_id
              );
              setsurveyHistory(filter);
            }
          } catch (error) {
            console.log(error);
            Swal.close();
          }
        }
      });
    }
  };

  const handleFavoriteLawGroup = async (item) => {
    let array = [];
    if (userState.favorite_law_group) {
      array = userState.favorite_law_group.split(',');
    }

    // array.push(item);
    if (array.includes(item.toString())) {
      array = array.filter((x) => x != item);
    } else {
      if (array[0] == '') {
        array[0] = item;
      } else {
        array.push(item);
      }
    }
    const model = {
      favorite_law_group: array.join(','),
    };
    try {
      const update = await ApiUser.updateFirst(model);
      if (update.status == 200) {
        const { data } = update;
        dispatch({ type: 'set_user', user: data });
      }
    } catch (error) {}
  };

  return (
    <div>
      <div class='column02Alter'>
        <div
          class='alter-card02'
          style={{
            marginBottom: '172px',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {tabArr.map((res, i) => {
              var classActive = tabFlag0 == i ? 'active' : '';
              return (
                <div style={{ flex: 1 }} key={i}>
                  <div
                    className={
                      'subscribetabbottomborder01 d-flex-center ' + classActive
                    }
                    onClick={() => {
                      setTabFlag0(i);
                    }}
                  >
                    <img
                      src={StaticImage(res.tabLabelIcon)}
                      className='subscrie-landmark-duotone-4'
                    />
                    <label className='tab-label-userprofile'>
                      {res.tabLabel}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ padding: 20 }}>
            {tabFlag0 === 0 ? (
              // <SubscribeTab02
              //   userState={userState}
              //   handleFavoriteLawGroup={handleFavoriteLawGroup}
              //   law_group={law_group}
              // />
              <FavoriteHistory />
            ) : (
              tabFlag0 === 1 && (
                // <SubscribeTab01
                //   surveyHistory={surveyHistory}
                //   handleFavorite={handleFavorite}
                // />
                <FavoriteHistory />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscribeIndex;
